import * as Yup from "yup";
const loginInitialValues = {
  email: "",
  password: "",
};
const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email address *")
    .email("Invalid email address *")
    .required("User email is required *"),
  password: Yup.string()
    .min(4, "Password must be at least 4 characters long.")
    .required("Password required *"),
});

export { loginInitialValues, loginValidationSchema };
